import common from "../../utill/Common";

class MicroAtmService {
  getRedirectUrl = async (token, service_type, amount, mobile) => {
    const url = common.baseUrl + "user/matm/isu/initiate_transaction";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ service_type, amount, mobile, platform: "WEB" }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  report = async (
    token,
    from_date,
    to_date,
    status,
    service_type,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/matm/isu/report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        status,
        service_type,
        search_text,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new MicroAtmService();
